import {
    Box,
    Button,
    Flex,
    Menu,
    MenuButton,
    MenuDivider,
    MenuGroup,
    MenuItem,
    MenuList,
    Spinner,
    Text,
} from '@chakra-ui/react';
import { ConditionalComponent } from '@components/functionComponent';
import { TEMPLATE_TYPE, useDownloadTemplate } from '@pages/UploadSellout/hooks/mutate/useDownloadTemplate';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { DownloadIcon } from '@assets/icons';
import React from 'react';

const DownloadMenu = () => {
    const { mutate, isPending } = useDownloadTemplate();
    const handleDonwnloadTemplate = (templateType) => () => {
        mutate({ templateType });
    };
    return (
        <Menu matchWidth >
            {({ isOpen }) => (
                <>
                    <MenuButton
                        as={Button}
                        disabled={isPending}
                        isDisabled={isPending}
                        variant="outline"
                        borderColor="sagitarius.500"
                        gap={0}
                        rightIcon={
                            <ChevronDownIcon
                                color="sagitarius.600"
                                fontSize={'1.3rem'}
                                transform={`rotate(${isOpen ? 180 : 0}deg)`}
                            />
                        }
                    >
                        <Flex gap="8px" alignItems="center">
                            <ConditionalComponent statement={!isPending} fallback={<Spinner speed="1s" />}>
                                <Box>
                                    <DownloadIcon size={20} />
                                </Box>
                            </ConditionalComponent>
                            <Text ms={'.4rem'} fontSize={'1rem'} color={'sagitarius.600'}>
                                Download Template
                            </Text>
                        </Flex>
                    </MenuButton>
                    <MenuList minWidth="unset" padding="0" overflow="clip" borderColor={'neutral.200'} zIndex={10}>
                        <MenuGroup>
                            <MenuItem padding="12px" onClick={handleDonwnloadTemplate(TEMPLATE_TYPE.EMPTY)}>
                                Template Kosong
                            </MenuItem>
                            <MenuDivider margin="0" borderColor="neutral.200" opacity={1} />
                            <MenuItem padding="12px" onClick={handleDonwnloadTemplate(TEMPLATE_TYPE.DEFAULT)}>
                                Template Berisi Produk
                            </MenuItem>
                        </MenuGroup>
                    </MenuList>
                </>
            )}
        </Menu>
    );
};

export default DownloadMenu;
